import { tryFetch, HttpMethod, type HttpResponse } from '@/modules/services/http'
import type { AppSetting } from '../types/app.enums'

const BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

const getAppSettings = async (
  body: AppSetting[],
): Promise<HttpResponse<Record<AppSetting, string>, any>> =>
  await tryFetch<Record<AppSetting, string>, any>(
    HttpMethod.Post,
    BASE_URL,
    ['settings', 'application'],
    {
      body,
    },
  )

export const appApi = {
  getAppSettings,
}
